// React Dependencies
import React from 'react';

// Internal Dependencies
import UserModerationTable from './table';
import MText from '../common/MText';
import Colours from '../../styles/colours';

const UserModerationList = () => (
  <div>
    <div className="content-header">
      <MText variant="h1" text="User Moderation" bold colour={Colours.Gray6} />
    </div>

    <UserModerationTable />
  </div>
);

export default UserModerationList;
